import getMessagesForNamespaces from "@lib/i18n/getMessagesForNamespaces";
import CanonicalUrl from "@components/layout/CanonicalUrl";
import GiftCardRedeemView from "@components/views/GiftCards/GiftCardRedeem";

const GiftCardRedeem = () => (
  <>
    <CanonicalUrl />
    <GiftCardRedeemView />
  </>
);

export async function getServerSideProps({ params: { locale } }) {
  return {
    props: {
      headerBehaviors: { noFooter: true },
      ...(await getMessagesForNamespaces(locale, ["common", "gift_cards"])),
    },
  };
}

GiftCardRedeem.requireAuth = false;

export default GiftCardRedeem;
